import Immutable from 'immutable';
const LOAD = 'schedule/LOAD';
const LOAD_SUCCESS = 'schedule/LOAD_SUCCESS';
const LOAD_FAIL = 'schedule/LOAD_FAIL';

const LOAD_TIMEOFF = 'schedule/LOAD_TIMEOFF';
const LOAD_TIMEOFF_SUCCESS = 'schedule/LOAD_TIMEOFF_SUCCESS';
const LOAD_TIMEOFF_FAIL = 'schedule/LOAD_TIMEOFF_FAIL';

const LOAD_PRACTICE = 'schedule/LOAD_PRACTICE';
const LOAD_FAIL_PRACTICE = 'schedule/LOAD_FAIL_PRACTICE';
const CLOSE_ERROR_MESSAGE = 'schedule/CLOSE_ERROR_MESSAGE';

const LOAD_MULTIPLE = 'schedule/LOAD_MULTIPLE';
const LOAD_MULTIPLE_SUCCESS = 'schedule/LOAD_MULTIPLE_SUCCESS';
const LOAD_MULTIPLE_FAIL = 'schedule/LOAD_MULTIPLE_FAIL';

const LOAD_SCHEDULE_NOTES_SUCCESS = 'schedule/LOAD_SCHEDULE_NOTES_SUCCESS';
const LOAD_SCHEDULE_NOTES_FAIL = 'schedule/LOAD_SCHEDULE_NOTES_FAIL';

const LOAD_NOTE_CATEGORIES_SUCCESS = 'schedule/LOAD_NOTE_CATEGORIES_SUCCESS';
const LOAD_NOTE_CATEGORIES_FAIL = 'schedule/LOAD_NOTE_CATEGORIES_FAIL';




const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  schedule: null,
  scheduleMultiple: null,
  scheduleNotes: null,
  noteCategories: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
          .set('isLoad', false)
          .set('loadErr', null)
          .set('schedule', action.res);

    case LOAD_NOTE_CATEGORIES_SUCCESS:
      return state
          .set('isLoad', false)
          .set('loadErr', null)
          .set('noteCategories', action.res);

    case LOAD_NOTE_CATEGORIES_FAIL:
      return state
          .set('isLoad', false)
          .set('loadErr', null)
          .set('noteCategories', []);

    case LOAD_MULTIPLE_SUCCESS:
      return state
          .set('isLoad', false)
          .set('loadErr', null)
          .set('scheduleMultiple', action.res);

    case LOAD_SCHEDULE_NOTES_SUCCESS:
      return state
          .set('isLoad', false)
          .set('loadErr', null)
          .set('scheduleNotes', action.res);

    case LOAD_SCHEDULE_NOTES_FAIL:
      return state
          .set('isLoad', false)
          .set('loadErr', action.error)
          .set('scheduleNotes', null);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('schedule', null);

    case LOAD_TIMEOFF:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_TIMEOFF_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null);

    case LOAD_TIMEOFF_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error);

    case CLOSE_ERROR_MESSAGE:
      return state
        .set('loadErr', null);


    default:
      return state;
  }
};

export const hideErrorModal = () => async (dispatch, getState, api) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const getScheduleData = (userId, params = '') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`/scheduler/getSchedules/${userId}${params}`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getScheduleNotes = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/scheduler/getScheduleNotes/${params}`);
    dispatch({ type: LOAD_SCHEDULE_NOTES_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_SCHEDULE_NOTES_FAIL, error: err.message });
  }
};

export const getMultipleScheduleData = (userId, params = '') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_MULTIPLE });
  try {
    let res = await api.post('/scheduler/getMultipleSchedules',{ data: params, userId:userId });
    dispatch({ type: LOAD_MULTIPLE_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_MULTIPLE_FAIL, error: err.message });
  }
};

/**
 * Fetches multiple schedule data specifically for exporting reports.
 * This action does NOT dispatch to the Redux store, preventing UI re-renders.
 * It returns a promise that resolves with the raw data.
 */
export const fetchMultipleScheduleDataForExport = (params, parameters) => async (dispatch, getState, api) => {
    return new Promise((resolve, reject) => {
        api.post('/scheduler/getMultipleSchedules', { data: parameters, userId: null })
            .then(res => {
                // Directly resolve with the data from the API response
                resolve(res);
            })
            .catch(err => {
                console.error("Failed to fetch schedule data for export", err);
                reject(err);
            });
    });
};

export const getNotesById = (id) => async (dispatch, getState, api) => {
  try {
    let res = await api.get('/scheduler/getNotesById/'+id);
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const timeOffRequest = ( data ) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_TIMEOFF });
  try {
    let res = await api.post('/timeOff/requestTimeOff', { data: data });
    dispatch({ type: LOAD_TIMEOFF_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_TIMEOFF_FAIL, error: err.message });
    return false;
  }
};

export const deleteNotes = (data) => async (dispatch, getState, api) => {

  try {
    let res = await api.put('/scheduler/deleteNotes', {data});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const publishNotes = (reportObj) => async (dispatch, getState, api) => {
  try {
      if(reportObj && reportObj.receipts){
          reportObj.receipts = JSON.stringify(reportObj.receipts);
      }
    let res = await api.post('/scheduler/publishNotes', {data:reportObj});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const publishHygNotes = (reportObj) => async (dispatch, getState, api) => {
  try {
    let res = await api.post('/finNotes', {data:reportObj, apiType: 'goApi'});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};


export const updateHygNotes = (reportObj) => async (dispatch, getState, api) => {
  try {
    let res = await api.put(`/finNotes/${reportObj.id}`, {data: reportObj, apiType: 'goApi'});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const deleteHygNotes = (id) => async (dispatch, getState, api) => {
  try {
    await api.del(`/finNotes/${id}`, {apiType: 'goApi'});
    return true;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const getPracticesList = (doctorId) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_PRACTICE });

  try {
    let res = await api.get(`/scheduler/getPractices?doctorId=`+doctorId);
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL_PRACTICE, error: err.message });
  }
};


export const getScheduledDoctorList = (monthYear) => async (dispatch, getState, api) => {
  try {
    dispatch({ type: LOAD });
    return await api.get(`/scheduler/getSchedulesDoctors/${monthYear}`);
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return [];
  }
};

export const getFinancialNoteCategories = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/scheduler/financial-note-categories`);
    dispatch({ type: LOAD_NOTE_CATEGORIES_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_NOTE_CATEGORIES_FAIL, error: err.message });
  }
};
